import TagInput from './component';
import { TagInputProps } from './types';

export default TagInput;
export type { TagInputProps };
